import moment from 'moment'
import WP from 'WP';

const periodNames = [
  'winter',
  'summer',
  'northern_lights'
];

export const getSeason = (fromDate, toDate, activity) => {
    let fromMonth = parseInt(fromDate.split('').slice(0, 2).join('')) - 1;
    let fromDay = fromDate.split('').slice(3, 5).join('');
    let toMonth = parseInt(toDate.split('').slice(0, 2).join('')) - 1;
    let toDay = toDate.split('').slice(3, 5).join('');

    const eventStart = moment().month(fromMonth).date(fromDay).add(1, 'hour');
    const eventEnd = moment().month(toMonth).date(toDay).subtract(1, 'hour');
    const eventStartNextYear = moment(eventStart).add(1, 'year');
    const eventEndNextYear = moment(eventEnd).add(1, 'year');

    if(eventEnd.isBefore(eventStart)) eventEnd.add(1, 'year');

    let periods = [];

    periodNames.forEach(period => {
        let startMonth = parseInt(WP.options[`${period}_from_date`].split('').slice(0,2).join('')) - 1;
        let startDay = WP.options[`${period}_from_date`].split('').slice(2,4).join('');
        let endMonth = parseInt(WP.options[`${period}_to_date`].split('').slice(0,2).join('')) - 1;
        let endDay = WP.options[`${period}_to_date`].split('').slice(2,4).join('');
        const start = moment().month(startMonth).date(startDay)
        const end = moment().month(endMonth).date(endDay);

        if(parseInt(endMonth) < parseInt(startMonth)) {
            end.add(1, 'year')
        }

        periods.push({
            name: period,
            start: start,
            end: end,
        });

        periods.push({
            name: period,
            start: start.clone().add(1, 'year'),
            end: end.clone().add(1, 'year'),
        });
    })

    let relevantPeriods = [];

    periods.map(period => {
        let insidePeriod = eventStart.isBetween(period.start, period.end) && eventEnd.isBetween(period.start, period.end) || eventStartNextYear.isBetween(period.start, period.end) && eventEndNextYear.isBetween(period.start, period.end);
        let startsInside = eventStart.isBetween(period.start, period.end) || eventStartNextYear.isBetween(period.start, period.end);
        let endsInside = eventEnd.isBetween(period.start, period.end) || eventEndNextYear.isBetween(period.start, period.end);
        let touchesInside = eventStart.isBefore(period.start) && eventEnd.isAfter(period.end) || eventStartNextYear.isBefore(period.start) && eventEndNextYear.isAfter(period.end);
    
        if(insidePeriod || startsInside || endsInside || touchesInside) relevantPeriods.push(period.name);
    });
    
    return relevantPeriods;
} 